module.exports = __webpack_public_path__ + "static/media/Ferdous.260e74b7.jpg";